import styled from 'styled-components';

import { UiTypography } from '@/components/ui/Typography';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';

export const PageStyles = styled(OnboardingPage)`
  ion-content {
    &::part(scroll) {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      margin-top: 16px;
    }

    .app-logo {
      margin: 0 0 20px;
    }

    .loading-wrapper {
      margin-top: auto;
      padding-bottom: 24px;
      width: 90%;
    }
  }

  #root .ion-page & {
    ion-footer {
      padding: 16px 16px 32px;

      .page-footer-button {
        font-size: 14px;
        font-weight: 600;
        line-height: 20px;
        border-radius: 12px;
      }
    }
  }
`;

export const PageTitleStyles = styled(UiTypography)`
  .ion-page & {
    margin: 0 0 20px;
    font-weight: 600;
  }
`;

export const PageSubtitleStyles = styled(UiTypography)`
  .ion-page & {
    color: transparent;
    background: linear-gradient(136deg, #7f36f3 -3.67%, #ed0d80 106.36%);
    background-clip: text;
  }
`;

export const ImagesContainer = styled.div`
  position: relative;
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px 0;
  z-index: 0;
`;

export const BackgroundImage = styled.img`
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 1;
`;

export const MainImage = styled.img`
  position: relative;
  z-index: 2;
  width: 80%;
`;

export const MessageBubbleImage = styled.img`
  position: absolute;
  top: 65%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 3;
  width: 60%;
  max-width: 300px;
  pointer-events: none;
`;
